document.addEventListener('alpine:init', () => {
  var { getElFromHtmlString } = Alpine.store('utilities');

  function miniCart(data = {}) {
    return {
      ...data,

      isLoading: false,

      init() {
        document.addEventListener('cartitemchangestart', () => this.isLoading = true);
        document.addEventListener('cartitemchangeend', () => this.isLoading = false);

        document.addEventListener('productformsubmitsuccess', (event) => this.render(event.detail.res));
        document.addEventListener('cartitemchangesuccess', (event) => this.render(event.detail.res));
      },

      render(res) {
        this.$nextTick(() => {
          var newEl = getElFromHtmlString(res.sections['mini-cart'], '.shopify-section').firstElementChild;

          Alpine.morph(this.$el, newEl.outerHTML);
        });
      }
    };
  };

  Alpine.data('miniCart', miniCart);
});
